import { useEffect, useRef } from 'react';

import Counter from '@components/Counter/Counter';
import DateInput from '@components/DateInput/DateInput';

import { KidInterface } from './ListingSearchGuestInterface';
import {
  GuestChildAgePicker,
  StyledListingGuestRoom,
  GuestRoomBlock,
  GuestRoomInfo,
  GuestRoomSubtitle,
  GuestRoomText,
  GuestRoomTitle,
} from './SearchGuestStyle';

interface SearchGuestItemProps {
  title: string;
  subTitle: string;
  count: number;
  handleDecrement: () => void;
  handleIncrement: () => void;
  isChildCounter?: boolean;
  min?: number;
  childrenList?: Array<KidInterface>;
  changeChildAge?: (kidId: string, age: string) => void | null;
  isSingleLineDatePicker?: boolean;
}
const ListingSearchGuestItem: React.FC<SearchGuestItemProps> = (props) => {
  const GuestChildAgePickerRef = useRef<HTMLDivElement>(null);
  // ================================
  // Getting the props for the component
  // ================================
  const {
    title,
    subTitle,
    handleIncrement,
    handleDecrement,
    count,
    isChildCounter,
    childrenList,
    changeChildAge,
    min,
    isSingleLineDatePicker = false,
  } = props;

  // ================================
  // Render the child date picker
  // ================================
  const renderKidsDatePicker = (): React.ReactElement[] | undefined => {
    if (!childrenList) return;

    return childrenList.map((item, index) => (
      <DateInput
        date={item.age}
        data-testid='date-input-guest-item'
        label={`${Number(index + 1).toString()}. Çocuk Doğum Tarihi`}
        error={item.error}
        key={index}
        handleDatePick={(e, b) => {
          if (changeChildAge) changeChildAge(item.id, b);
        }}
        isChild={true}
      />
    ));
  };

  // ================================
  // Render the main component jsx
  // ================================

  useEffect(() => {
    GuestChildAgePickerRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [count]);

  return (
    <StyledListingGuestRoom>
      <GuestRoomBlock>
        <GuestRoomInfo>
          <GuestRoomText>
            <GuestRoomTitle>{title}</GuestRoomTitle>
            <GuestRoomSubtitle>{subTitle}</GuestRoomSubtitle>
          </GuestRoomText>
        </GuestRoomInfo>

        <Counter
          handleIncrement={handleIncrement}
          handleDecrement={handleDecrement}
          count={count}
          min={min}
        />
      </GuestRoomBlock>

      {isChildCounter && isChildCounter === true && count > 0 ? (
        <>
          <br />
          <GuestChildAgePicker
            isSingleLine={isSingleLineDatePicker}
            data-testid='child-counter-picker'
            ref={GuestChildAgePickerRef}
          >
            {renderKidsDatePicker()}
          </GuestChildAgePicker>
        </>
      ) : null}
    </StyledListingGuestRoom>
  );
};

export default ListingSearchGuestItem;
